import {
    CLOCK_CIRCLE_CENTER,
    CLOCK_CIRCLE_RADIUS,
    CLOCK_POLYLINE_POINTS,
    CLOCK_STROKE_WIDTH,
    ICON_SIZE,
    ICON_STROKE_WIDTH,
    PIN_CIRCLE_CX,
    PIN_CIRCLE_CY,
    PIN_CIRCLE_R,
    PIN_TEARDROP,
    STAR_PATH
} from './constants';
import type { ResultRowKind } from './types';

import styles from './styles.module.scss';

// Each helper returns a fully-formed SVG glyph. Kept in a sibling file to
// keep ResultRow/index.tsx under the 100-line component budget.

const ClockGlyph = (): JSX.Element => (
    <svg
        aria-hidden='true'
        className={styles.glyph}
        fill='none'
        height={ICON_SIZE}
        viewBox={`0 0 ${ICON_SIZE} ${ICON_SIZE}`}
        width={ICON_SIZE}
        xmlns='http://www.w3.org/2000/svg'>
        <circle
            cx={CLOCK_CIRCLE_CENTER}
            cy={CLOCK_CIRCLE_CENTER}
            r={CLOCK_CIRCLE_RADIUS}
            stroke='currentColor'
            strokeWidth={CLOCK_STROKE_WIDTH}
        />

        <polyline
            fill='none'
            points={CLOCK_POLYLINE_POINTS}
            stroke='currentColor'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={CLOCK_STROKE_WIDTH}
        />
    </svg>
);

const StarGlyph = (): JSX.Element => (
    <svg
        aria-hidden='true'
        className={styles.glyph}
        height={ICON_SIZE}
        viewBox={`0 0 ${ICON_SIZE} ${ICON_SIZE}`}
        width={ICON_SIZE}
        xmlns='http://www.w3.org/2000/svg'>
        <path d={STAR_PATH} fill='currentColor' />
    </svg>
);

const PinGlyph = (): JSX.Element => (
    <svg
        aria-hidden='true'
        className={styles.glyph}
        fill='none'
        height={ICON_SIZE}
        viewBox={`0 0 ${ICON_SIZE} ${ICON_SIZE}`}
        width={ICON_SIZE}
        xmlns='http://www.w3.org/2000/svg'>
        <path
            d={PIN_TEARDROP}
            stroke='currentColor'
            strokeLinejoin='round'
            strokeWidth={ICON_STROKE_WIDTH}
        />

        <circle
            cx={PIN_CIRCLE_CX}
            cy={PIN_CIRCLE_CY}
            r={PIN_CIRCLE_R}
            stroke='currentColor'
            strokeWidth={ICON_STROKE_WIDTH}
        />
    </svg>
);

const GLYPH_FOR_KIND: Record<ResultRowKind, () => JSX.Element> = {
    airport: StarGlyph,
    place: PinGlyph,
    recent: ClockGlyph
};

export const renderGlyphForKind = (kind: ResultRowKind): JSX.Element => {
    const Glyph = GLYPH_FOR_KIND[kind];

    return <Glyph />;
};
